import React from "react";


const RightarrowIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12.947" height="10.66" viewBox="0 0 12.947 10.66">
            <g id="Component_1_60" data-name="Component 1 – 60" transform="translate(0.75 1.061)">
                <g id="Group_44" data-name="Group 44" transform="translate(-6.447 -8)">
                <line id="Line_55" data-name="Line 55" x2="11.154" transform="translate(6.447 12.269)" fill="none" stroke="#0182f0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                <path id="Path_267" data-name="Path 267" d="M13,8l4.269,4.269L13,16.539" transform="translate(0.625)" fill="none" stroke="#0182f0" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
            </g>
        </svg>

    );

}

export default RightarrowIcon;